import {
  InfiniteListBase,
  ShowBase,
  useShowContext,
  useTranslate,
} from "ra-core";
import { useParams, useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

import { NotesIterator } from "./NotesIterator";
import { NoteCreate } from "./NoteCreate";
import type { Contact } from "../types";

const ContactNotesPageContent = () => {
  const { record, isPending } = useShowContext<Contact>();
  const navigate = useNavigate();
  const translate = useTranslate();
  const { id } = useParams<{ id: string }>();

  if (isPending || !record) return null;

  return (
    <div className="mt-2 mb-2">
      <div className="flex items-center gap-2 mb-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate(`/contacts/${id}/show`)}
        >
          <ArrowLeft className="size-5" />
        </Button>
        <div>
          <h2 className="text-xl font-semibold">
            {record.first_name} {record.last_name}
          </h2>
          <p className="text-sm text-muted-foreground">
            {translate("resources.notes.name", { smart_count: 2 })}
          </p>
        </div>
      </div>
      <Card>
        <CardContent>
          <InfiniteListBase
            resource="contact_notes"
            filter={{ contact_id: record.id }}
            sort={{ field: "date", order: "DESC" }}
            perPage={25}
            disableSyncWithLocation
            storeKey={false}
            empty={
              <NoteCreate reference="contacts" showStatus className="mt-4" />
            }
          >
            <NotesIterator reference="contacts" showStatus />
          </InfiniteListBase>
        </CardContent>
      </Card>
    </div>
  );
};

export const ContactNotesPage = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <ShowBase resource="contacts" id={id}>
      <ContactNotesPageContent />
    </ShowBase>
  );
};
